import { RpcError } from "grpc-web";
import {
  DeleteFolderRequest,
  DeleteFolderResponse,
  Folder,
  GetFoldersRequest,
} from "../proto/api_pb";
import { GetFoldersResponse } from "../proto/api_pb";
import { PostFolderRequest, PostFolderResponse } from "../proto/api_pb";
import { OmmuseClient } from "../proto/api_grpc_web_pb";
import { backOff } from "exponential-backoff";

export const postFolder = async (
  token: string,
  folder: Folder
): Promise<RpcError | PostFolderResponse | undefined> => {
  try {
    const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
    const request = new PostFolderRequest();
    request.setFolder(folder);

    const metadata = {
      Authorization: `${token}`,
      "Access-Control-Allow-Origin": "*",
    };

    return await backOff(
      () =>
        new Promise<PostFolderResponse | RpcError>((resolve, reject) => {
          ommuseClient.postFolder(request, metadata, function (err, response) {
            if (err) {
              reject(err);
            } else {
              resolve(response);
            }
          });
        }),
      {
        numOfAttempts: 3,
        jitter: "full",
      }
    );
  } catch (e) {
    console.log(e);
  }
};

export const getAllFolders = async (
  token: string,
  userId: string
): Promise<RpcError | GetFoldersResponse | undefined> => {
  try {
    const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
    const request = new GetFoldersRequest();
    request.setUserId(userId);

    const metadata = {
      Authorization: `${token}`,
      "Access-Control-Allow-Origin": "*",
    };

    return await backOff(
      () =>
        new Promise<RpcError | GetFoldersResponse>((resolve, reject) => {
          ommuseClient.getFolders(request, metadata, function (err, response) {
            if (err) {
              reject(err);
            } else {
              resolve(response);
            }
          });
        }),
      {
        numOfAttempts: 3,
        jitter: "full",
      }
    );
  } catch (e) {
    console.log(e);
  }
};

export const deleteFolder = async (
  token: string,
  id: string
): Promise<RpcError | DeleteFolderResponse | undefined> => {
  try {
    const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
    const request = new DeleteFolderRequest();
    request.setId(id);

    const metadata = {
      Authorization: `${token}`,
      "Access-Control-Allow-Origin": "*",
    };

    return await backOff(
      () =>
        new Promise<RpcError | DeleteFolderResponse>((resolve, reject) => {
          ommuseClient.deleteFolder(
            request,
            metadata,
            function (err, response) {
              if (err) {
                reject(err);
              } else {
                resolve(response);
              }
            }
          );
        }),
      {
        numOfAttempts: 3,
        jitter: "full",
      }
    );
  } catch (e) {
    console.log(e);
  }
};
